import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-cyan-900 ${className}`} data-id="element-311">
      <div className="container mx-auto px-4" data-id="element-312">
        {title && <h2 className="font-bold text-center mb-12 text-white text-[16px]" data-id="element-313">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-314">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-cyan-950/70 p-6 rounded-2xl shadow-lg border border-cyan-800 flex flex-col h-full" data-id="element-315">
              <div className="flex items-center gap-1 mb-4" data-id="element-316">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-317" />)}
              </div>

              <p className="text-cyan-50 italic mb-6 flex-grow" data-id="element-318">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-cyan-800/60" data-id="element-319">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-320">
                  {t.initials}
                </div>
                <div data-id="element-321">
                  <p className="font-bold text-white text-sm" data-id="element-322">{t.name}</p>
                  <p className="text-xs text-cyan-200" data-id="element-323">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-cyan-300 mt-0.5" data-id="element-324">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials = [{
  initials: 'LM',
  name: 'Lucía M.',
  location: 'Terapeuta ABA · Córdoba',
  text: 'Nunca pensé que iba a tener todo el material de una primera sesión armado antes de que llegara el paciente. Entré con seguridad, con planillas, con protocolo. Mis primeras sesiones cambiaron completamente.',
  color: 'bg-cyan-600'
}, {
  initials: 'CP',
  name: 'Carolina P.',
  location: 'Mamá y AT · Rosario',
  text: 'Mi hijo tiene TEA y empecé a trabajar con él en casa. Este material me dio las herramientas que ningún profesional me había explicado de forma clara. Por fin entiendo por qué hace lo que hace.',
  color: 'bg-pink-500'
}, {
  initials: 'SM',
  name: 'Sofía M.',
  location: 'Docente de Apoyo · Buenos Aires',
  text: 'Soy maestra integradora y llevaba años improvisando. El Tomo 4 me dio todo lo que necesitaba para el aula en un solo lugar. Se lo recomiendo a toda mi red.',
  color: 'bg-purple-500'
}];
export const moreTestimonials = [{
  initials: 'MR',
  name: 'Martina R.',
  location: '🏙️ Mendoza',
  pack: 'MegaPack ABA Listo',
  text: 'Soy AT y llevaba meses sin saber exactamente cómo registrar. El Tomo 6 me dio todo el sistema de planillas y en una semana mis informes a la Obra Social mejoraron completamente.',
  color: 'bg-emerald-500'
}, {
  initials: 'JF',
  name: 'Julián F.',
  location: '🏙️ Buenos Aires',
  pack: 'MegaPack ABA Listo',
  text: 'Trabajo con un niño con TEA que tenía conductas de golpe cada vez que le pedía algo. El Tomo 3 me dio el protocolo de análisis funcional que necesitaba. En tres semanas la frecuencia bajó a la mitad.',
  color: 'bg-cyan-700'
}, {
  initials: 'AG',
  name: 'Adriana G.',
  location: '🏙️ La Plata',
  pack: 'MegaPack ABA Listo',
  text: 'Soy psicopedagoga y no tenía formación específica en ABA. Este material me dio la base técnica y las planillas listas para trabajar con mis pacientes con TEA sin improvisar más.',
  color: 'bg-amber-500'
}, {
  initials: 'DP',
  name: 'Diego P.',
  location: '🏙️ Neuquén',
  pack: 'MegaPack + Sistema Maestro',
  text: 'El Sistema Maestro me cambió la práctica. Antes el AT hacía lo que podía. Ahora tengo la ficha del paciente, el algoritmo de consecuencia y la auditoría mensual. Los datos mejoraron en dos semanas.',
  color: 'bg-slate-700'
}, {
  initials: 'KL',
  name: 'Karina L.',
  location: '🏙️ Rosario',
  pack: 'MegaPack + Sistema Maestro',
  text: 'Tengo 8 pacientes y la documentación me consumía. El informe mensual que me llevaba 4 horas ahora lo hago en 45 minutos. Solo eso ya valió el precio del upsell.',
  color: 'bg-rose-500'
}];